import React, { useEffect } from "react";
import ToolBoxTalkUserList from "../component/toolBoxTalkList/toolBoxTalkUserList";
import { useDispatch, useSelector } from "react-redux";
import { ORG_ID, USER_ID } from "../../../constant/constant";
import * as toolboxAction from "../../../redux/actions/toolBoxAction";
import * as adminAction from "../../../redux/actions/adminCommonAction";
import { useLocation } from "react-router-dom";
import {
  TOOL_BOX_USER,
  TOOL_BOX_DETAIL,
  TOOL_BOX_USERCOUNT_ASSIGN,
} from "../../../constant/routeContant";
import { getPreviousRoute } from "../../../utils/routeTracker";
import { getUserBaseDivisionInfo } from "../../../utils/helper";

const ToolboxTalkUserContainer = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { hasBaseDivisionAdminAccess, baseDivisionIds } =
    getUserBaseDivisionInfo();

  const getSafetyMeetingUser = () => {
    if (location?.state?.safetyMeetingUser !== undefined) {
      sessionStorage.setItem(
        "safetyMeetingUser",
        location.state.safetyMeetingUser.toString(),
      );
      return location.state.safetyMeetingUser;
    }
    const stored = sessionStorage.getItem("safetyMeetingUser");
    return stored === "true";
  };
  const safetyMeetingUser = getSafetyMeetingUser();
  const PAGE_SIZE = 6;
  const defaultTab = location?.state?.defaultTab;
  const mySafetyMeetingListResult = useSelector(
    (state) => state.mySafetyMeetingList?.data,
  );
  const mySafetyMeetingListState = useSelector(
    (state) => state.mySafetyMeetingList,
  );
  const cleardata = () => {
    dispatch(toolboxAction.clearMySafetyMeetingList(""));
  };
  const dropdownDataKeyValue = useSelector(
    (state) => state.getDropdownDataKeyValue?.data?.toolboxCategories,
  );

  const getAdminToolBoxTalkListData = useSelector(
    (state) => state.getAdminToolBoxTalkList,
  );

  const defaultData = {
    page: 1,
    pageSize: PAGE_SIZE,
    search: "",
    userId: parseInt(USER_ID()),
    tabId: defaultTab === 1 ? 3 : 2,
    divisionId: 0,
  };

  useEffect(() => {
    const data = mySafetyMeetingListState?.filterObj
      ? {
          ...mySafetyMeetingListState.filterObj,
          tabId:
            mySafetyMeetingListState.filterObj.tabId ??
            (defaultTab === 1 ? 3 : 2),
        }
      : { ...defaultData, tabId: defaultTab === 1 ? 3 : 2 };
    getMySafetyMeetingListData(data);
    dispatch(toolboxAction.getScheduleSafetyMeetingDetailsClear(""));
  }, [defaultTab]);

  useEffect(() => {
    const allowedRoutes = [
      TOOL_BOX_USER,
      TOOL_BOX_DETAIL,
      TOOL_BOX_USERCOUNT_ASSIGN,
    ];
    const currentPathname = location.pathname;
    if (currentPathname === TOOL_BOX_USER) {
      const previousRoute = getPreviousRoute();
      const isFromEditRoute =
        previousRoute && previousRoute.startsWith("/create-safety-meeting");
      if (
        previousRoute &&
        !allowedRoutes.includes(previousRoute) &&
        !isFromEditRoute
      ) {
        dispatch(toolboxAction.getMySafetyMeetingListFilterObj(defaultData));
        getMySafetyMeetingListData(defaultData);
      }
    }
  }, [location.pathname, dispatch]);

  const getMySafetyMeetingListData = (data) => {
    const payload = {
      ...data,
      divisionId: data?.divisionId ?? 0,
    };
    dispatch(toolboxAction.getMySafetyMeetingListFilterObj(payload));
    dispatch(toolboxAction.clearUserDetailTalk(payload));
    dispatch(toolboxAction.getMySafetyMeetingList(payload));
  };

  const getDropdownDataKeyValueData = {
    orgId: ORG_ID(),
    flags: [20],
  };

  useEffect(() => {
    dispatch(adminAction.getDropdownDataKeyValue(getDropdownDataKeyValueData));
  }, []);

  const getAdminToolBoxTalkList = (data) => {
    dispatch(toolboxAction.getAdminToolBoxTalkList(data));
  };
  return (
    <>
      <ToolBoxTalkUserList
        categoryListData={dropdownDataKeyValue}
        getToolBoxTalkListResult={mySafetyMeetingListResult}
        getToolBoxTalkListData={getMySafetyMeetingListData}
        getToolBoxTalkListAdmin={getAdminToolBoxTalkList}
        getAdminToolBoxTalkListDataLoading={
          getAdminToolBoxTalkListData?.isLoading
        }
        getAdminToolBoxTalkListData={getAdminToolBoxTalkListData?.data}
        safetyMeetingUser={safetyMeetingUser}
        cleardata={cleardata}
        getfilterObjListDataList={mySafetyMeetingListState}
      />
    </>
  );
};

export default ToolboxTalkUserContainer;
